import React from "react";
import PropTypes from "prop-types";

import { DeliveryRow } from "./Deliveries/DeliveryRow";
import { OrderLine } from "./OrderLine";

/*
 * Ligne commande du dry-run / simulation. Rend le composant NATIF `DeliveryRow` (même rendu que l'écran
 * dispatch : nom client, badges, adresse, créneau) à partir de la task sérialisée par le back
 * (`tasks[order.id]`), sans dépendre du store live. Un error boundary garantit qu'une task incomplète ou
 * une donnée de store manquante fait retomber CETTE ligne sur `OrderLine` — jamais toute la page.
 */
const SHOW = {
  displayMode: "one_line", name: true, menu: false, driver: false, status: false,
  sms: false, late: false, withSelect: false, addressFormatting: "compact",
  directDispatch: false, externalCall: false,
};
// Fenêtre de livraison projetée « au plus tôt→au plus tard » + heure de livraison projetée par la lib.
// La tournée figée part au dernier moment → elle livre au plus tard, donc l'heure projetée = eta_max.
const deliveryWindow = (o) => {
  if (!o.eta_min) { return ""; }
  const projected = o.eta_max || o.eta_min;
  const range =
    o.eta_max && o.eta_max !== o.eta_min ? `${o.eta_min}→${o.eta_max}` : o.eta_min;
  return `${range} (${projected})`;
};

export class TaskRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    // Silencieux : le repli OrderLine prend le relais pour cette ligne.
  }

  render() {
    const { order, tasks } = this.props;
    const task = tasks ? tasks[order.id] : null;
    if (task && !this.state.failed) {
      return (
        <DeliveryRow
          task={task}
          dock={null}
          show={SHOW}
          addressFormatting="compact"
          deliveryWindow={deliveryWindow(order)}
        />
      );
    }
    return <OrderLine order={order} />;
  }
}
TaskRow.propTypes = { order: PropTypes.object, tasks: PropTypes.object };
